// extracted by mini-css-extract-plugin
export var slideUp = "slide-up-module--slide-up--mehvd";
export var slideUp_show = "slide-up-module--slide-up_show--dS3fe";